import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useUserPermissions = () => {
  const { profile, currentOrganization, effectiveRole } = useAuth();

  return useQuery({
    queryKey: ['user-permissions', profile?.id, currentOrganization?.id],
    queryFn: async () => {
      if (!profile || effectiveRole === 'superadmin') {
        return { hasAdminAccess: effectiveRole === 'superadmin' };
      }

      if (!currentOrganization) {
        return { hasAdminAccess: false };
      }

      // Check if user has administrator role in any club within the current organization
      const { data: clubRoles, error } = await supabase
        .from('user_club_roles')
        .select(`
          role,
          is_active,
          clubs!inner(
            organization_id
          )
        `)
        .eq('user_id', profile.id)
        .eq('role', 'administrator')
        .eq('is_active', true)
        .eq('clubs.organization_id', currentOrganization.id);

      if (error) {
        console.error('Error checking user permissions:', error);
        return { hasAdminAccess: false };
      }

      return { hasAdminAccess: (clubRoles?.length || 0) > 0 };
    },
    enabled: !!profile,
  });
};